import { DEFAULT_PLACEHOLDER } from '@constants/generic';
import useCurrency from '@hooks/useCurrency';

interface CurrencyAmountProps {
  value: number | string | null | undefined;
  className?: string;
  symbolClass?: string;
  valueClass?: string;
  placeholder?: string;
}

const CurrencyAmount = ({
  value,
  className,
  symbolClass,
  valueClass,
  placeholder = DEFAULT_PLACEHOLDER
}: CurrencyAmountProps) => {
  const { formatCurrencyValue } = useCurrency();

  const numericValue = typeof value === 'string' ? parseFloat(value) : value;
  const isValidNumber =
    numericValue !== null &&
    numericValue !== undefined &&
    Number.isFinite(numericValue);

  if (!isValidNumber) {
    return <span className={valueClass}>{placeholder}</span>;
  }

  const formattedCurrency = formatCurrencyValue(numericValue);

  return (
    <div className={`flex items-baseline ${className}`}>
      <div className={`font-inter text-[0.875em] ${symbolClass}`}>
        {formattedCurrency.symbol}
      </div>
      <div className={valueClass}>{formattedCurrency.value}</div>
    </div>
  );
};

export default CurrencyAmount;
